import { createTheme } from "@mui/material";

export const SEARCH_BUTTON_COLOR = '#ED2F42';

const theme = createTheme({
    palette: {
        primary: {
            light: '#fff',
            main: '#231F20',
            dark: '#3A98B8'
        },
        secondary: {
            main: '#1755be',
            light: '#D9D9D9',
            dark: '#000'
        },
        text: {
            primary: '#5d5d5d',
            secondary: '#fff',
        }
    }
});

export default theme;